import React, { useState, useRef, useEffect } from "react";

import PropTypes from "prop-types";

// import styled from '@mui/styles/styled';
// import { ExpandMore } from '@material-ui/icons';
import { HiOutlineChevronDown } from "react-icons/hi";
import { BiCreditCard } from "react-icons/bi";
import { BsCreditCard2Front, BsTrash } from "react-icons/bs";
// import MuiAccordion from '@mui/material/Accordion';
// import MuiAccordionDetails from '@mui/material/AccordionDetails';
// import MuiAccordionSummary from '@mui/material/AccordionSummary';

import api from "../../_services/api";
import notify from "../../components/UI/toast";
import ModalApp from "../../components/ModalApp";
import { FormNewCard } from "../../components/FormCard";

import { styled } from "@mui/material/styles";
import { Accordion as MuiAccordion } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import {
  HeaderLabel,
  Label,
  ContainerLabel,
  Card,
  Title,
  CreditCardButton,
} from "./styles";

import pagarme from "pagarme/browser";

import { useUserData } from "../../hooks/UserContext";
import { useApp } from "../../contexts/AppContext";
import axios from "axios";

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  padding: "0",
  margin: "0",
  boxShadow: "0",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    borderTop: "none",
  },
  borderBottom: `1px solid ${theme?.whitelabel?.theme?.text_primary_color}`,
  "&:not(:last-child)": {},
  "&:before": {
    display: "none",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: theme?.whitelabel?.theme?.text_primary_color,
    "& svg": {
      color: theme?.whitelabel?.theme?.text_primary_color,
    },
  },
}));

export default function CreditCardList({
  cards,
  openNewCard,
  onSelected,
  onSaveCard,
  onRefreshCards,
  title,
  closeNewCard,
  Loading,
}) {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const [selected, setSelected] = useState(null);
  const [boxNewCard, setBoxNewCard] = useState(false);
  const radioGroupRef = useRef(null);

  useEffect(() => {
    setBoxNewCard(false);
  }, [closeNewCard]);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  const handleSelect = (value) => {
    setSelected(value);
    onSelected(value);
    setExpandedPanel(false);
  };

  const toggleOpenModal = () => {
    openNewCard();
    setBoxNewCard(!boxNewCard);
  };

  const { user, userData, mainCard, setMainCard } = useUserData();
  const { whitelabel } = useApp();
  const dataUser = userData.data;

  const saveNewCard = async (values) => {
    const card_pagarme = {
      card_number: values.card_number,
      card_holder_name: values.card_holder_name,
      card_expiration_date: values.card_expiration_date?.replace("/", ""),
      card_cvv: values.card_cvv,
    };

    let cardValidations = pagarme.validate({ card: card_pagarme });

    if (!cardValidations.card.card_holder_name) {
      notify("Verifique o nome impresso no cartão.", "error");
      return false;
    }
    if (!cardValidations.card.card_number) {
      notify("Verifique o número do cartão.", "error");
      return false;
    }
    if (!cardValidations.card.card_expiration_date) {
      notify("Verifique a data de expiração do cartão.", "error");
      return false;
    }
    if (!cardValidations.card.card_cvv) {
      notify("Verifique o código de segurança (CVV) do cartão.", "error");
      return false;
    }

    const cardNumber = values.card_number.replaceAll(" ", "");
    const expirationMonth = values.card_expiration_date.split("/")[0];
    const expirationYear = values.card_expiration_date.split("/")[1];

    const payload = {
      type: "card",
      card: {
        number: cardNumber,
        holder_name: values.card_holder_name,
        exp_month: expirationMonth,
        exp_year: expirationYear,
        cvv: values.card_cvv,
      },
    };

    const options = {
      method: "POST",
      url: `${process.env.REACT_APP_PAGARME_API}?appId=${process.env.REACT_APP_PAGARME_APPID}`,
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      data: payload,
    };

    const { data, status } = await axios.request(options);

    if (status !== 200) {
      notify("Erro ao cadastrar dados do cartão.", "error");
      return;
    }

  let card_hash = data?.id;
  onSaveCard(values, card_hash);
  };

  function onClickDelCard(uuid_Card) {
    try {
      api
        .delete(
          "/api/delete-card?cardUuid=" +
            uuid_Card +
            "&customerUuid=" +
            dataUser?.uuid
        )
        .then((result) => {
          if (result.status) {
            onRefreshCards();
            return notify("Cartão removido com sucesso", "success");
          }
          return notify(result.message, "error");
        });
    } catch (err) {
      console.log(err);
      notify("Erro ao deletar cartão.", "error");
    }
  }

  useEffect(() => {
    if (radioGroupRef.current) {
      const firstRadioButton = radioGroupRef.current.querySelector(
        'input[type="radio"]'
      );
      firstRadioButton.checked = true;
      handleSelect(firstRadioButton.value);
    }
  }, []);

  return (
    <>
      <ModalApp show={boxNewCard} handleModal={() => toggleOpenModal()}>
        <FormNewCard
          saveNewCard={saveNewCard}
          onCancel={toggleOpenModal}
          cards={cards}
          Loading={Loading}
        />
      </ModalApp>
      <h3 
        className="font-wl-500 text-mg my-2 pt-1" 
        style={{ color: whitelabel?.theme?.text_primary_color }}
      >
        {title}
      </h3>
      {cards.length > 0 ? (
        <Accordion
          expanded={expandedPanel === "panel1"}
          onChange={handleAccordionChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<HiOutlineChevronDown style={{ color: whitelabel?.theme?.text_primary_color }} />}
            className="p-0"
            onClick={() => toggleOpenModal()}
          >
            {mainCard ? (
              <ContainerLabel>
                <Label>
                  <BiCreditCard size={20} style={{ color: whitelabel?.theme?.text_primary_color }} />{" "}
                  {`XXXX  ${mainCard.last_four_digits} (${
                    mainCard.brand || "Desconhecido"
                  })`}
                </Label>
              </ContainerLabel>
            ) : (
              cards
                .filter((card) => card.main === true)
                .map((item, index) => (
                  <ContainerLabel key={index}>
                    <Label>
                      <BiCreditCard size={20} style={{ color: whitelabel?.theme?.text_primary_color }} />{" "}
                      {`XXXX  ${item.last_four_digits} (${
                        item.brand || "Desconhecido"
                      })`}
                    </Label>
                  </ContainerLabel>
                ))
            )}
          </AccordionSummary>

          {/* <AccordionDetails>
            <FormControl fullWidth>
              <RadioGroup
                onChange={(e) => handleSelect(e.target.value)}
                ref={radioGroupRef}
                value={selected}
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={0}
                name="radio-buttons-group"
              >
                {cards.map((item, index) => (
                  <Card key={index}>
                    <FormControlLabel
                      value={item.hash}
                      control={<Radio />}
                      label={`XXXX  ${item.last_four_digits} (${
                        item.brand || "Desconhecido"
                      })`}
                    />
                    {/*<BsTrash onClick={() => onClickDelCard(item.uuid)}/>*/}
          {/* </Card>
                ))}
              </RadioGroup>
            </FormControl>
          </AccordionDetails>  */}

          {/* <CreditCardButton
            type="button"
            onClick={() => toggleOpenModal()}
            style={{ padding: "10px 0" }}
          >
            <BsCreditCard2Front />
            Cadastre um cartão de crédito
          </CreditCardButton> */}
        </Accordion>
      ) : (
        <Accordion
          expanded={expandedPanel === "panel1"}
          onChange={handleAccordionChange("panel1")}
          className="pb-2"
        >
          <AccordionSummary
            expandIcon={<HiOutlineChevronDown style={{ color: whitelabel?.theme?.text_primary_color }} />}
            className="p-0"
          >
            <CreditCardButton type="button" onClick={() => toggleOpenModal()}>
              <BsCreditCard2Front />
              Cadastre um cartão de crédito
            </CreditCardButton>
          </AccordionSummary>
        </Accordion>
      )}
    </>
  );
}

CreditCardList.propTypes = {
  cards: PropTypes.array,
  openNewCard: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
  onSelected: PropTypes.func,
  onSaveCard: PropTypes.func,
  onRefreshCards: PropTypes.func,
  closeNewCard: PropTypes.bool,
  Loading: PropTypes.bool,
};
